import React from 'react'
import Proptype from 'prop-types'
import classnames from 'classnames/bind'
import { Text } from '@adc/ui-adc'
import styles from './index.scss'
const cx = classnames.bind(styles)

const Detail = ({ label, value, format, elmId }) => {
  const formattedValue = format ? format(value) : value
  return (
    <div className={cx('detail-box')}>
      <Text data-elm-id={`${elmId}_value`} weight='heavy'>
        {formattedValue || '-'}
      </Text>
      <Text data-elm-id={`${elmId}_label`} color='gray'>
        {label}
      </Text>
    </div>
  )
}

Detail.propTypes = {
  label: Proptype.string.isRequired,
  value: Proptype.number.isRequired,
  format: Proptype.func,
  elmId: Proptype.string,
}

export default Detail
